import * as types from "../actions/ActionTypes";
import initialState from "./InitialState";

export default function consultantsReducer(state = initialState.consultants, action) {
  switch (action.type) {
    case types.LOAD_CONSULTANTS_SUCCESS:
      return action.consultants;
    default:
      return state;
  }
}
